import request from '@/axios'

export const getMenuListApi = () => {
  return request.get({ url: '/mock/menu/list' })
}

export const getOnlyMenuTreeApi = (params) => {
  return request.get({
    url: '/ors-system/menu/list',
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    params
  })
}
